/**
 * Convierte un color CSS (hex, rgb, rgba) a componentes Lottie [r,g,b,a] en rango 0–1.
 * Devuelve null si el valor no es parseable (p. ej. transparent sin alpha útil).
 */
export function parseCssColorToLottieRgba(css: string): [number, number, number, number] | null {
	const raw = css.trim().toLowerCase();
	if (raw === '' || raw === 'transparent') {
		return null;
	}
	if (raw.startsWith('#')) {
		return parseHexToLottieRgba(raw);
	}
	if (raw.startsWith('rgb')) {
		return parseRgbFunctionToLottieRgba(raw);
	}
	return null;
}

function parseHexToLottieRgba(hex: string): [number, number, number, number] | null {
	let h = hex.slice(1);
	if (h.length === 3) {
		h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
	}
	if (h.length !== 6 && h.length !== 8) {
		return null;
	}
	const n = Number.parseInt(h, 16);
	if (Number.isNaN(n)) {
		return null;
	}
	if (h.length === 6) {
		const r = (n >> 16) & 255;
		const g = (n >> 8) & 255;
		const b = n & 255;
		return [r / 255, g / 255, b / 255, 1];
	}
	const r = (n >> 24) & 255;
	const g = (n >> 16) & 255;
	const b = (n >> 8) & 255;
	const a = n & 255;
	return [r / 255, g / 255, b / 255, a / 255];
}

function parseRgbFunctionToLottieRgba(input: string): [number, number, number, number] | null {
	const inner = input.replace(/^rgba?\(\s*/, '').replace(/\s*\)\s*$/, '');
	const parts = inner.split(/\s*,\s*/);
	if (parts.length < 3) {
		return null;
	}
	const r = clampByte(parseFloat(parts[0]));
	const g = clampByte(parseFloat(parts[1]));
	const b = clampByte(parseFloat(parts[2]));
	const a = parts.length >= 4 ? clampUnit(parseFloat(parts[3])) : 1;
	if ([r, g, b, a].some((x) => Number.isNaN(x))) {
		return null;
	}
	return [r / 255, g / 255, b / 255, a];
}

function clampByte(n: number): number {
	if (Number.isNaN(n)) {
		return Number.NaN;
	}
	return Math.max(0, Math.min(255, n));
}

function clampUnit(n: number): number {
	if (Number.isNaN(n)) {
		return Number.NaN;
	}
	return Math.max(0, Math.min(1, n));
}
